import { ShareObjectStatus } from './Share';

export enum UserRoleForDataset {
    BusinessOwner = 'BusinessOwner',
    DataSteward = 'DataSteward',
    Creator = 'Creator',
    Admin = 'Admin',
    Shared = 'Shared',
    NoPermission = 'NoPermission',
}
interface NewDatasetStorageLocationInput {
    label: string;
    prefix: string;
}

interface StatusProps {
    status?: string;
    color: string;
    icon: React.JSX.Element;
    tooltip?: string;
}
interface DatasetStatistics {
    tables: number;
    locations: number;
}

interface StorageLocation {
    locationUri: string;
    created: string;
    S3Prefix: string;
    AwsAccountId: string;
    labels: string;
}
interface DatasetTable {
    tableUri: string;
    name: string;
    created: string;
    GlueDatabaseName: string;
}

interface DatasetListItem {
    label: string;
    description: string;
    created: string;
    updated?: string;
    statistics: DatasetStatistics;
    datasetUri: string;
    userRoleForDataset: UserRoleForDataset;
    shares?: {
        nodes: {
            status: ShareObjectStatus;
        }[];
    };
    organization: { label: string };
    status: StatusProps;
    __typename: string;
}

export const datasetDefault = {
    created: '',
    datasetUri: '',
    label: '',
    description: '',
    environment: { environmentUri: '' },
    organizationUri: '',
    SamlAdminGroupName: '',
    owner: '',
    businessOwnerEmail: '',
    businessOwnerDelegationEmails: [],
    tags: [],
    userRoleForDataset: UserRoleForDataset.NoPermission,
    stack: {
        status: '',
        terminationProtection: '',
    },
};
export interface Dataset {
    label: string;
    created: string;
    description: string;
    organizationUri: string;
    SamlAdminGroupName: string;
    userRoleForDataset: UserRoleForDataset;
    owner: string;
    businessOwnerEmail: string;
    businessOwnerDelegationEmails: string[];
    tags: string[];
    datasetStageOptions?: string;
    enableCrawler?: boolean;
    enableReadTrail?: boolean;
    bucketName?: string;
    datasetUri: string;
    targetS3BucketName?: string;
    stack: {
        status: string;
        terminationProtection: string;
    };
    environment: { environmentUri: string };
}
interface DatasetListResult {
    nodes: DatasetListItem[];
    count: number;
    page: number;
    pages: number;
}
export type {
    DatasetListItem,
    DatasetListResult,
    StatusProps,
    DatasetStatistics,
    DatasetTable,
    NewDatasetStorageLocationInput,
    StorageLocation,
};
